const t = "[a-zA-Z_:][a-zA-Z0-9:._-]*", o = "[^\"'=<>`\\x00-\\x20]+", s = "'[^']*'", n = '"[^"]*"', a = "(?:" + o + "|" + s + "|" + n + ")", e = "(?:\\s+" + t + "(?:\\s*=\\s*" + a + ")?)", _ = "<[A-Za-z][A-Za-z0-9\\-]*" + e + "*\\s*\\/?>", c = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", u = new RegExp("^(?:" + _ + "|" + c + ")");
export {
  u as HTML_OPEN_CLOSE_TAG_RE
};
